import { type ActiveState, createEntityStore, type EntityState } from '@datorama/akita';
import { type GridSortModel } from '@mui/x-data-grid-premium';
import { type User } from 'types/models';

export interface UsersState extends EntityState<User>, ActiveState {
   sortModel: GridSortModel;
   searchTerm?: string;
}

export const initialState = {
   sortModel: [],
   searchTerm: undefined,
};

const store = createEntityStore<UsersState>(initialState, { resettable: true, name: 'users' });

export default store;
